export const SLACK_CONNECTED_EVENT = `slack-app-installed`;
export const SLACK_BROADCAST_CHANNEL_NAME = `slack-broadcast-channel`;
